
export const cdnUrl = 'https://hsqtjxg.cdn.bcebos.com'